import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="pb-16 bg-brand-bone min-h-screen" data-testid="privacy-page">
      {/* Hero */}
      <section className="bg-brand-black/[0.03] py-12 md:py-20 border-b border-brand-cobalt/10">
        <div className="max-w-4xl mx-auto px-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-sm text-brand-cobalt hover:text-brand-cobalt/80 mb-6"
          >
            <ArrowLeft size={16} />
            Volver al inicio
          </Link>
          <h1 className="font-display text-3xl md:text-5xl tracking-tight mb-4 text-brand-black">
            Aviso de Privacidad
          </h1>
          <p className="text-brand-black/60 text-lg">
            Última actualización: Diciembre 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            <p className="text-brand-black/80 leading-relaxed mb-8">
              En cumplimiento con la Ley Federal de Protección de Datos Personales en Posesión de
              los Particulares, Alphatica informa a los usuarios de su sitio web sobre el tratamiento de
              sus datos personales.
            </p>

            <h2 className="font-display text-xl md:text-2xl mt-10 mb-4 text-brand-cobalt">Datos personales recopilados</h2>
            <p className="text-brand-black/80 mb-4">Al utilizar el sitio web de Alphatica, se podrán recopilar los siguientes datos:</p>
            <ul className="space-y-2 text-brand-black/80 mb-8">
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Nombre completo
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Dirección de correo electrónico
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Número de teléfono
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Dirección de envío
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Información de facturación
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Historial de compras
              </li>
            </ul>

            <h2 className="font-display text-xl md:text-2xl mt-10 mb-4 text-brand-cobalt">Finalidad del uso de datos</h2>
            <p className="text-brand-black/80 mb-4">Los datos personales recopilados se utilizan para:</p>
            <ul className="space-y-2 text-brand-black/80 mb-8">
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Procesar pedidos
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Realizar envíos
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Brindar atención al cliente
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Enviar notificaciones relacionadas con pedidos
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Mejorar la experiencia del usuario en el sitio web
              </li>
            </ul>

            <h2 className="font-display text-xl md:text-2xl mt-10 mb-4 text-brand-cobalt">Protección de datos</h2>
            <p className="text-brand-black/80 mb-8">
              Alphatica implementa medidas de seguridad administrativas, técnicas y físicas para
              proteger la información personal de los usuarios.
            </p>

            <h2 className="font-display text-xl md:text-2xl mt-10 mb-4 text-brand-cobalt">Transferencia de datos</h2>
            <p className="text-brand-black/80 mb-4">
              Los datos personales podrán compartirse únicamente con terceros cuando sea necesario
              para la operación del servicio, como:
            </p>
            <ul className="space-y-2 text-brand-black/80">
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Empresas de mensajería
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Plataformas de pago
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                Servicios tecnológicos utilizados para el funcionamiento del sitio
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
